import { render, staticRenderFns } from "./addAuth.vue?vue&type=template&id=0bfa5a40"
import script from "./addAuth.vue?vue&type=script&lang=js"
export * from "./addAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports